import fornecedorRotas from './fornecedores/FornecedorRotas'
import uabsRotas from './uabs/UabsRotas'
import gestoresRotas from './gestores/GestoresRotas'
import unidadesRegionaisRotas from './unidadesRegionais/UnidadesRegionaisRotas'

export default {
    path: 'consultorias',
    name: 'AppSebrae_Consultorias',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        fornecedorRotas,
        uabsRotas,
        gestoresRotas,
        unidadesRegionaisRotas
    ]
}
